import { render, staticRenderFns } from "./scPlaylistItemWidget.vue?vue&type=template&id=5ac8a5af&scoped=true&"
import script from "./scPlaylistItemWidget.vue?vue&type=script&lang=js&"
export * from "./scPlaylistItemWidget.vue?vue&type=script&lang=js&"
import style0 from "./scPlaylistItemWidget.vue?vue&type=style&index=0&id=5ac8a5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8a5af",
  null
  
)

export default component.exports